import { getRouteForLastSelectedTab } from '~/services/teamMembers'
import { handleAsyncDataErrors } from '~/cynqueModules/handleAsyncDataErrors'
import { getNuxtContext } from '~/cynqueModules/nuxtRuntime'
import { useLoggedInUserStore } from '~/stores/loggedInUser'

// Named middleware — applied by pages/Home/index.vue via definePageMeta (Nuxt 4
// dropped the Nuxt-2 `middleware` component option). Redirects /Home to the
// team member's last-selected tab (or Companies for non-team-member users).
export default defineNuxtRouteMiddleware(async () => {
  const fn = `[middleware/homeRedirect]`
  const teamMember = useLoggedInUserStore().getLoggedInTeamMember
  if (!teamMember) {
    console.debug(
      `${fn} login user is not teamMember user. Pushing 'Companies'.`
    )
    return navigateTo({
      name: 'Companies',
    })
  }
  const id = teamMember.id
  try {
    const pathToPush = await getRouteForLastSelectedTab(id)
    console.debug(`${fn} redirecting to '${pathToPush}', id '${id}'`)
    return navigateTo({
      name: pathToPush,
      params: { id },
    })
  } catch (error) {
    console.debug(`${fn} failed`)
    handleAsyncDataErrors({
      callingMn: fn,
      error,
      context: getNuxtContext(),
    })
  }
})
